/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @version 1.10.0
 * @since 1.0.1
 */

import { icons } from '../../../assets';
import { FlexStyled } from '../../common/Block/Flexbox';
import { ImgStyled } from '../../common/Block/Img';
import {
    HelpTipsBlockStyled,
    HelpTipsContainerStyled,
    TipsClosedStyled,
    TipsTextStyled,
} from '../styled/HeaderStyled';

export interface IHelpTipsProps {
    contextHelpText: string;
    onCloseHelpTips: () => void;
}

const HelpTips = (props: IHelpTipsProps) => {
    return (
        <HelpTipsContainerStyled>
            <HelpTipsBlockStyled>
                <FlexStyled alignItems='center'>
                    <ImgStyled
                        className="small has-info"
                        data-header-icon="iconInfo"
                        src={icons.infoBlackSmallIcon}
                    />
                    <TipsTextStyled>
                        {props.contextHelpText}
                    </TipsTextStyled>

                    <TipsClosedStyled>
                        <ImgStyled
                            className="small"
                            src={icons.cancelOpacitySmallIcon}
                            onClick={props.onCloseHelpTips}
                        />
                    </TipsClosedStyled>
                </FlexStyled>
            </HelpTipsBlockStyled>
        </HelpTipsContainerStyled>
    );
};

export default HelpTips;
